export default __webpack_public_path__ + "static/media/Pistol_2.6549e301.png";